import { Controller } from "@hotwired/stimulus";

// Load Ace editor dynamically from CDN
async function loadAce() {
  if (window.ace) return window.ace;

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/ace.js";
    script.onload = () => {
      // Also load the html mode
      const modeScript = document.createElement("script");
      modeScript.src =
        "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/mode-html.js";
      modeScript.onload = () => resolve(window.ace);
      modeScript.onerror = reject;
      document.head.appendChild(modeScript);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Connects to data-controller="ace-editor"
export default class extends Controller {
  async connect() {
    if (!document.getElementById("#ace-editor-style")) {
      const link = document.createElement("link");
      link.id = "ace-editor-style";
      link.href =
        "https://cdn.jsdelivr.net/npm/ace-builds@1.30.0/css/ace.min.css";
      link.rel = "stylesheet";
      document.body.append(link);
    }

    // Load Ace editor
    await loadAce();

    const div = document.createElement("div");

    this.element.after(div);
    this.element.style.display = "none";
    if (!this.element.dataset.aceified) {
      this.element.dataset.aceified = true;

      const editor = ace.edit(div);

      editor.session.setValue(this.element.value);
      editor.session.setMode("ace/mode/html");
      editor.session.setUseWorker(false);
      editor.setOptions({
        autoScrollEditorIntoView: true,
        copyWithEmptySelection: true,
        highlightActiveLine: false,
        showPrintMargin: false,
        tabSize: 2,
        useSoftTabs: true,
        wrap: true,
        wrapBehavioursEnabled: true,
      });

      editor.commands.addCommand({
        name: "submitForm",
        bindKey: { win: "Ctrl-Enter", mac: "Command-Enter" },
        exec: (editor) => {
          // Code to submit the form
          this.element.form.requestSubmit();
        },
      });

      this.editor = editor;
      this.editorDiv = div;
      this.boundSubmit = () => {
        this.element.value = this.editor.getSession().getValue();
      };
      this.element.form.addEventListener("submit", this.boundSubmit);
    }
  }

  disconnect() {
    if (this.boundSubmit && this.element.form) {
      this.element.form.removeEventListener("submit", this.boundSubmit);
    }
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
    if (this.editorDiv) {
      this.editorDiv.remove();
      this.editorDiv = null;
    }
  }
}
